import {
  signIn,
  signOut,
  signUp,
  confirmSignUp,
  signInWithRedirect,
  resetPassword,
  confirmResetPassword,
} from 'aws-amplify/auth';
import { userApi } from '../services/api-client';

export const useAuth = () => {
  const loginWithGoogle = async () => {
    try {
      await signInWithRedirect({ provider: 'Google' });
      return { success: true };
    } catch (error: any) {
      return { success: false, error: error.message || 'Google sign-in failed' };
    }
  };

  const login = async (email: string, password: string) => {
    try {
      const result = await signIn({
        username: email,
        password,
      });

      // Auto-register user in database if not already registered
      try {
        await userApi.register();
        console.log('User registered in database');
      } catch (registerError: any) {
        // Check if it's a "already registered" error vs a real error
        const errorMessage = registerError?.message || '';
        if (!errorMessage.includes('already registered')) {
          console.error('Failed to register user in database:', registerError);
          // Don't block login, but log the error
        }
      }

      return { success: true, result };
    } catch (error: any) {
      return { success: false, error: error.message || 'Login failed' };
    }
  };

  const register = async (email: string, password: string, displayName?: string) => {
    try {
      const result = await signUp({
        username: email,
        password,
        options: {
          userAttributes: {
            email,
            ...(displayName && { 'custom:displayName': displayName }),
          },
        },
      });
      return { success: true, result };
    } catch (error: any) {
      return { success: false, error: error.message || 'Registration failed' };
    }
  };

  const confirm = async (email: string, code: string) => {
    try {
      await confirmSignUp({
        username: email,
        confirmationCode: code,
      });
      return { success: true };
    } catch (error: any) {
      return { success: false, error: error.message || 'Confirmation failed' };
    }
  };

  const forgotPassword = async (email: string) => {
    try {
      await resetPassword({ username: email });
      return { success: true };
    } catch (error: any) {
      return { success: false, error: error.message || 'Failed to send reset code' };
    }
  };

  const forgotPasswordSubmit = async (email: string, code: string, newPassword: string) => {
    try {
      await confirmResetPassword({ username: email, confirmationCode: code, newPassword });
      return { success: true };
    } catch (error: any) {
      return { success: false, error: error.message || 'Failed to reset password' };
    }
  };

  const logout = async () => {
    try {
      await signOut();
      return { success: true };
    } catch (error: any) {
      return { success: false, error: error.message || 'Logout failed' };
    }
  };

  return {
    login,
    loginWithGoogle,
    register,
    confirm,
    forgotPassword,
    forgotPasswordSubmit,
    logout,
  };
};
